import Cookies from 'js-cookie';
import axios from 'axios';

/**
 * Logout from application
 */
export const logout = () => {
  const cookiePath = '/';
  const cookieDomain = process.env.REACT_APP_DOMAIN;
  const loginUrl = process.env.REACT_APP_LOGIN_BASE_URL;
  const sourceUrl = encodeURIComponent(
    window.location.href.replace('login', '').replace('error', '')
  );

  const cookies = document.cookie.split(';');
  cookies.map((cookie) => {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie =
      name +
      '=;expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=' +
      process.env.REACT_APP_DOMAIN +
      '; path=/';
    if (name.includes('product_landing_popup_')) {
      Cookies.remove(name, {
        path: cookiePath,
        domain: process.env.REACT_APP_DOMAIN,
      });
    }
    return '';
  });

  Cookies.remove(process.env.REACT_APP_EXPIRY_TIME, {
    path: cookiePath,
    domain: cookieDomain,
  });
  Cookies.remove(process.env.REACT_APP_ACCESS_TOKEN, {
    path: cookiePath,
    domain: cookieDomain,
  });
  Cookies.remove('access_token_expiry_time', {
    path: cookiePath,
    domain: cookieDomain,
  });
  Cookies.remove('access_token_expiry_length', {
    path: cookiePath,
    domain: cookieDomain,
  });
  Cookies.remove('survey_disclaimer_accepted', {
    path: cookiePath,
    domain: cookieDomain,
  });

  const action =
    loginUrl +
    '/app/logout?source=' +
    (sourceUrl ? sourceUrl : process.env.REACT_APP_BASE_URL);
  const logoutForm = document.createElement('FORM');
  const button = document.createElement('input');
  button.setAttribute('type', 'submit');
  button.setAttribute('style', 'display:none;');
  logoutForm.name = 'logout';
  logoutForm.method = 'POST';
  logoutForm.action = action;
  logoutForm.appendChild(button);
  document.body.appendChild(logoutForm);
  logoutForm.submit();
};

/**
 * Method to keep alive the user
 * If continusly work even after
 * one hour of token expiry
 *
 * Only using raw js date funtions to avoid
 * Moment package (Heavy weight)
 *
 * @param {object} response
 */
export function responseSuccessInterceptor(response) {
  const expiryTime = Cookies.get(process.env.REACT_APP_EXPIRY_TIME);
  if (
    !expiryTime ||
    new Date(decodeURIComponent(expiryTime)).getTime() < new Date().getTime()
  ) {
    const timePlus5Mins = new Date(
      new Date().setSeconds(new Date().getSeconds() + 300)
    );
    const nextCheckTime =
      (timePlus5Mins.getMonth() + 1).toString().padStart(2, '0') +
      '/' +
      timePlus5Mins.getDate().toString().padStart(2, '0') +
      '/' +
      timePlus5Mins.getFullYear().toString().padStart(4, '0') +
      ' ' +
      timePlus5Mins.getHours().toString().padStart(2, '0') +
      ':' +
      timePlus5Mins.getMinutes().toString().padStart(2, '0') +
      ':' +
      timePlus5Mins.getSeconds().toString().padStart(2, '0');
    Cookies.set(process.env.REACT_APP_EXPIRY_TIME, nextCheckTime, {
      path: '/',
      domain: process.env.REACT_APP_DOMAIN,
    });
    fetch(
      process.env.REACT_APP_NEXTGEN_BASE_URL +
        '/api/token/accesstoken/validitystate',
      {
        method: 'GET',
        credentials: 'include',
        redirect: 'follow',
      }
    )
      .then((validitystateResponse) => {
        if (validitystateResponse.status === 401) {
          logout();
        }
        return validitystateResponse.json();
      })
      .then((checkData) => {
        if (checkData.logoutUser) {
          logout();
        } else {
          const expireTime = checkData.accessTokenExpiresIn
            ? checkData.accessTokenExpiresIn
            : 900;
          if (
            checkData.generateNewAccessToken ||
            parseInt(expireTime, 10) - 900 <= 0
          ) {
            fetch(
              process.env.REACT_APP_NEXTGEN_BASE_URL + '/api/token/accesstoken',
              {
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  'anti-csrf-token': Cookies.get(
                    process.env.REACT_APP_ENV === 'production'
                      ? 'anti-csrf-token'
                      : process.env.REACT_APP_ENV + '_anti-csrf-token'
                  ),
                },
                method: 'POST',
                credentials: 'include',
                redirect: 'follow',
                body: JSON.stringify({
                  replaceAccessTokenCookie: true,
                }),
              }
            )
              .then((rawData) => {
                if (rawData.status === 401) {
                  logout();
                }
                return rawData.json();
              })
              .catch((error) => {
                console.log('error:', error);
                logout();
              });
          }
        }
      })
      .catch((error) => {
        console.log('error:', error);
        logout();
      });
  }
  return response;
}

/**
 * API error handler
 * @param {object} error
 */
export function responseErrorInterceptor(error) {
  if (error?.response?.status === 401) {
    logout();
  }
  return Promise.reject(error);
}

/**
 * Axios Rest Config
 */
const commonConfig = {
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
};

/**
 * Nextgen API calls
 */
export const nextgenApiClient = axios.create({
  ...commonConfig,
  baseURL: process.env.REACT_APP_NEXTGEN_BASE_URL,
});
nextgenApiClient.interceptors.response.use(
  responseSuccessInterceptor,
  responseErrorInterceptor
);

/**
 * Tools Social API calls
 */
export const toolsSocialApiClient = axios.create({
  ...commonConfig,
  baseURL: process.env.REACT_APP_TOOLS_SOCIAL_BASE_URL,
});
toolsSocialApiClient.interceptors.response.use(
  responseSuccessInterceptor,
  responseErrorInterceptor
);

/**
 * Social Crawler API calls
 */
export const socialCrawlerApiClient = axios.create({
  ...commonConfig,
  baseURL: `${process.env.REACT_APP_SOCIAL_CRAWLER_BASE_URL}/api`,
});
socialCrawlerApiClient.interceptors.response.use(
  responseSuccessInterceptor,
  responseErrorInterceptor
);
